/* 

This script injects styles into the pandectes-cmp shadow DOM after it loads. External CSS cannot pierce the shadow DOM boundary, so dynamic injection after loading is necessary.

*/

// Define the base path for assets from the Shopify CDN
document.addEventListener('DOMContentLoaded', () => {
	const ASSET_BASE_PATH = window.themeObject?.fonts?.path;

	// Color variables
	const colorPrimary = '#1a1a1a';
	const colorSecondary = '#fff';
	const colorTertiary = '#f6f6f6';
	const colorQuaternary = '#e7e7e7';
	const colorAccent = '#2a705b';

	// Font variables
	const fontHeadingsBold = "'PPME Bold', sans-serif";
	const fontBodyRegular = "'NHG Regular', sans-serif";
	const fontBodyMedium = "'NHG Medium', sans-serif";
	const fontBodyBold = "'NHG Bold', sans-serif";

	// Typography variables
	const fontSizeBody = 'clamp(0.75rem, 1vw, 1rem)';
	const borderQuaternary = `1px solid ${colorQuaternary}`;

	// Fonts data
	const FONTS = [
		{ family: 'NHG Regular', weight: 500, file: 'neue-haas-grotesk-regular' },
		{ family: 'NHG Medium', weight: 600, file: 'neue-haas-grotesk-medium' },
		{ family: 'NHG Bold', weight: 700, file: 'neue-haas-grotesk-bold' },
		{ family: 'PPME Regular', weight: 400, file: 'pp-monument-extended-regular' },
		{ family: 'PPME Bold', weight: 700, file: 'pp-monument-extended-bold' },
	];

	const fontFaces = FONTS.map(({ family, weight, file }) => `
		@font-face {
			font-family: '${family}';
			font-style: normal;
			font-weight: ${weight};
			font-display: swap;
			src: url('${ASSET_BASE_PATH}/${file}.woff2') format('woff2');
		}
	`).join('');

	// CSS template for shadow DOM injection
	const PANDECTES_STYLES = `
		${fontFaces}
		
		dialog {
			background-color: ${colorTertiary};
		}
		
		.shadow-dialog {
			box-shadow: 0 -1px 16px 0 rgba(var(--color-black-rgb),0.08);
		}

		.inner {
			gap: 0;
		}
		
		h2 {
			font-family: ${fontHeadingsBold};
			text-transform: uppercase;
			font-size: ${fontSizeBody};
			line-height: 1.25;
			letter-spacing: 0.01em;
		}

		.message,
		.description,
		.text-accent,
		.links {
			font-family: ${fontBodyRegular};
			font-size: ${fontSizeBody};
			line-height: 1.25;
			letter-spacing: 0.01em;
		}
		
		.trigger {
			font-family: ${fontBodyMedium};
			font-size: clamp(0.9rem, 1vw, 1rem);
			line-height: 1.25;
			letter-spacing: 0.01em;
		}

		.collapsible {
			padding-block: calc(var(--spacing) * 6);
		}

		.collapsible:before {
			border-top: ${borderQuaternary};
		}

		.actions.divided:before {
			border-top: ${borderQuaternary};
			opacity: 1;
		}

		button {
			font-family: ${fontBodyBold};
			font-size: 1rem;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			border: 0;
		}
		
		button.allow {
			background-color: ${colorAccent};
		}

		button.deny {
			border: 1px solid transparent;
		}

		button.deny:hover {
			background-color: transparent;
			border: 1px solid ${colorPrimary};
			color: ${colorPrimary};
		}

		button.outlined {
			background-color: transparent;
			border: 1px solid ${colorPrimary};
		}
		
		button.outlined:hover {
			background-color: ${colorPrimary};
			color: ${colorSecondary};
		}

		@media (min-width: 508px) and (max-width: 800px) {
			.inner {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				gap: 0.5rem;
			}

			.inner > .actions {
				justify-content: flex-start;
				width: 100%;
			}
		}

		@media (hover: hover) {
			div.actions button:hover {
				opacity: 1;
			}
		}
	`;

	// Function to style the pandectes-cmp element
	const stylePandectes = () => {
		const pandectesElement = document.querySelector('pandectes-cmp');
		const shadowRoot = pandectesElement?.shadowRoot;

		if (!shadowRoot) {
			return false;
		}

		if (shadowRoot.getElementById('pandectes-custom-styles')) {
			return true;
		}

		const styleEl = document.createElement('style');
		styleEl.id = 'pandectes-custom-styles';
		styleEl.textContent = PANDECTES_STYLES;

		shadowRoot.appendChild(styleEl);

		return true;
	};

	// Polling configuration
	const MAX_ATTEMPTS = 40;
	const RETRY_INTERVAL = 250;

	// Try immediately, then poll if necessary
	if (!stylePandectes()) {
		let attempts = 0;

		const intervalId = window.setInterval(() => {
			attempts += 1;

			if (stylePandectes() || attempts >= MAX_ATTEMPTS) {
				window.clearInterval(intervalId);
			}
		}, RETRY_INTERVAL);
	}

});
